var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoveable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-3651 -1177)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(3981 -21) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1198 330) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1205 330) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1212 330) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(3990 -21) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1198 330) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1205 330) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7-2",
    "data-name": "Ellipse 7",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1212 330) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveable);
export default __webpack_public_path__ + "static/media/moveable.e04681fd.svg";
export { ForwardRef as ReactComponent };